//http://stackoverflow.com/questions/1458724/how-do-i-set-unset-C-with-jquery
//$.C("test", 1, { expires : 10 });
//var CValue = $.C("test");

//http://stackoverflow.com/questions/6362688/jquery-check-if-C-exists-if-not-create-it
/*
if (typeof $.C('token') === 'undefined'){
 //no C
} else {
 //have C
}

if (!!$.C('token')) {
 //no C
} else {
 // have C
}
*/
//https://scotch.io/tutorials/easily-create-read-and-erase-Cs-with-jquery

/* Abrevations used for cookies saving in size limit */
/* 
advancedCalc	-	ACalc
Advanced		-	A
Step			-	S
Cookie			-	C
Valid			-	V
 */

var quickCalc = {};
var ACalc = {};
var NitrogenCalc = {'quickCalc': quickCalc, 'ACalc': ACalc};

export function setCalcValuesToCookie(){
	//console.log(NitrogenCalc);
	//console.log(1234567890);
//quick calc values
	/* value variables */
	//quickCalc.quickCostOfProductInstinctNServePerAcreC = $("#quick-cost-of-product-instinct-n-serve-per-acre").val();
	quickCalc.quickCostOfProductNServePerAcreC = $("#quick-cost-of-product-n-serve-per-acre").val();
	quickCalc.quickCostOfProductInstinctPerAcreC = $("#quick-cost-of-product-instinct-per-acre").val();
	quickCalc.quickCornYieldBushelsAcreC = $("#quick-corn-yield-bushels-acre").val();
	quickCalc.quickAverageYieldIncreaseWithProductInstinctNServeC = $("#quick-average-yield-increase-with-product-instinct-n-serve").val();
	quickCalc.quickCornPricePerBushelC = $("#quick-corn-price-per-bushel").val();
	quickCalc.quickTotalAcresC = $("#quick-total-acres").val();
	
	/*Results*/
	quickCalc.quickResultValueOfYieldIncreasePerAcreC = $("#quick-result-value-of-yield-increase-per-acre").text();
	quickCalc.quickResultValueOfYieldIncreaseForQuickTotalAcresC = $("#quick-result-value-of-yield-increase-for-quick-total-acres").text();
	quickCalc.quickEnteredInputTotalAcresC = $("#quick-entered-input-total-acres").text();

	
	NitrogenCalc = {'quickCalc': quickCalc, 'ACalc': ACalc};
	//console.log(NitrogenCalc);
	//eraseCookie("NitrogenCalcCookieQuickCalculator", "", -1);
	//eraseCookie("NitrogenCalcCookieAdvancedCalculator", "", -1);
	createCookie("NitrogenCalcCookieQuickCalculator", NitrogenCalc.quickCalc, 14);
	createCookie("NitrogenCalcCookieAdvancedCalculator", NitrogenCalc.ACalc, 14);
}

//get values from Cookie
export function getCalcValuesFromCookie(){
	var NitrogenCalcQuickCalculator = JSON.parse(readCookie("NitrogenCalcCookieQuickCalculator"));
	var NitrogenCalcAdvancedCalculator = JSON.parse(readCookie("NitrogenCalcCookieAdvancedCalculator"));
	NitrogenCalc.quickCalc = NitrogenCalcQuickCalculator;
	NitrogenCalc.ACalc = NitrogenCalcAdvancedCalculator;
	//console.log(NitrogenCalc);
	
//setting values to webpage based on C value
//quick calc values
	/* value variables */
	//$("#quick-cost-of-product-instinct-n-serve-per-acre").val(NitrogenCalc.quickCalc.quickCostOfProductInstinctNServePerAcreC);
	$("#quick-cost-of-product-n-serve-per-acre").val(NitrogenCalc.quickCalc.quickCostOfProductNServePerAcreC);
	$("#quick-cost-of-product-instinct-per-acre").val(NitrogenCalc.quickCalc.quickCostOfProductInstinctPerAcreC);
	$("#quick-corn-yield-bushels-acre").val(NitrogenCalc.quickCalc.quickCornYieldBushelsAcreC);
	$("#quick-average-yield-increase-with-product-instinct-n-serve").val(NitrogenCalc.quickCalc.quickAverageYieldIncreaseWithProductInstinctNServeC);
	$("#quick-corn-price-per-bushel").val(NitrogenCalc.quickCalc.quickCornPricePerBushelC);
	$("#quick-total-acres").val(NitrogenCalc.quickCalc.quickTotalAcresC);
	
	/*Results*/
	$("#quick-result-value-of-yield-increase-per-acre").text(NitrogenCalc.quickCalc.quickResultValueOfYieldIncreasePerAcreC);
	$("#quick-result-value-of-yield-increase-for-quick-total-acres").text(NitrogenCalc.quickCalc.quickResultValueOfYieldIncreaseForQuickTotalAcresC);
	$("#quick-entered-input-total-acres").text(NitrogenCalc.quickCalc.quickEnteredInputTotalAcresC);
	
}

$(document).ready(function(){
	if(checkCookie("NitrogenCalcCookieQuickCalculator") && checkCookie("NitrogenCalcCookieAdvancedCalculator")){
		//have Cookie
		getCalcValuesFromCookie();
	}
	else{
		//no Cookie, so set Cookie with values at first time default load
		//create Cookie from function setCalcValuesToCookie();
		//setCalcValuesToCookie();
	}
	//read Cookie
	//console.log(JSON.parse(readCookie("NitrogenCalcCookieQuickCalculator")));
	//console.log(JSON.parse(readCookie("NitrogenCalcCookieAdvancedCalculator")));
});

function createCookie(name,value,days) {
	//eraseCookie(name);
	//console.log("changed value");
	value = JSON.stringify(value);
	//console.log(value);
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name,value,days) {
    //createCookie(name,"",-1);
	console.log(name);
	//document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

//checkCookie("NitrogenCalcCookie");
function checkCookie(name) {
    var cookieExists=readCookie(name);
	//console.log(cookieExists);
    if (cookieExists != null) {
        //have cookie
		//console.log("have cookie");
		return true;
    } else {
        //no cookie
		//console.log("no cookie");
		return false;
    }
}
